import { rotuloTelmex } from '@/common/helpers/ProvedorTelmex'

const BASE = [
  { key: 'redirecionar',         label: 'Detalhes',            sortable: false },
  { key: 'vincular',            label: 'Vincular',            sortable: false },
  { key: 'workflow_nome',       label: 'Workflow',            sortable: false },
  { key: 'etapa_atual',         label: 'Tarefa/Etapa',        sortable: false },
  { key: 'aging_dias',          label: 'Aging',               sortable: false },
  { key: 'finalized_at',        label: 'Fechamento',          sortable: false },
  { key: 'ultima_atualizacao',  label: 'Última Atualização',  sortable: false },
  { key: 'provedor_nome',       label: 'Provedor',            sortable: false },
  { key: 'provedor_uf',         label: 'UF',                  sortable: false },
  { key: 'provedor_responsavel',label: 'Gestor - responsável',sortable: false },
]

const RECUPERACAO = [
  { key: 'numero_rec',               label: 'REC',                     sortable: false },
  { key: 'centro_funcional',         label: 'Centro Funcional',        sortable: false },
  { key: 'cliente_final',            label: 'Cliente Final',           sortable: false },
  { key: 'data_abertura_ticket',     label: 'Data de Abertura',        sortable: false },
  { key: 'data_atendimento_cliente', label: 'Previsão de atendimento', sortable: false },
  { key: 'designacao',               label: 'Designação Claro',        sortable: false },
  { key: 'designacao_provedor',      label: 'Designação Provedor',     sortable: false },
  { key: 'descricao_problema',       label: 'Causa',                   sortable: false },
]

const INSTALACAO = [
  { key: 'tipo_solicitacao', label: 'Tipo Solicitação', sortable: false },
  { key: 'tipo_servico',     label: 'Tipo de Serviço',  sortable: false },
  { key: 'regional_inst',    label: 'Regional',         sortable: false },
  { key: 'cod_circuito',     label: 'Circuito',         sortable: false },
  { key: 'os',               label: 'OS',               sortable: false },
]

const RECUPERACAO_ORDENADA = [
  { key: 'redirecionar',             label: 'Detalhes',                sortable: false },
  { key: 'vincular',                 label: 'Vincular',                sortable: false },
  { key: 'numero_rec',               label: 'REC',                     sortable: false },
  { key: 'centro_funcional',         label: 'Centro Funcional',        sortable: false },
  { key: 'cliente_final',            label: 'Cliente Final',           sortable: false },
  { key: 'descricao_problema',       label: 'Causa',                   sortable: false },
  { key: 'designacao',               label: 'Designação Claro',        sortable: false },
  { key: 'designacao_provedor',      label: 'Designação Provedor',     sortable: false },
  { key: 'provedor_uf',              label: 'UF',                      sortable: false },
  { key: 'data_abertura_ticket',     label: 'Data de Abertura',        sortable: false },
  { key: 'etapa_atual',              label: 'Tarefa/Etapa',            sortable: false },
  { key: 'ultima_atualizacao',       label: 'Última Atualização',      sortable: false },
  { key: 'finalized_at',             label: 'Fechamento',              sortable: false },
  { key: 'provedor_responsavel',     label: 'Gestor - responsável',    sortable: false },
  { key: 'data_atendimento_cliente', label: 'Previsão de atendimento', sortable: false },
  { key: 'aging_dias',               label: 'Aging',                   sortable: false },
  { key: 'workflow_nome',            label: 'Workflow',                sortable: false },
  { key: 'os',                       label: 'OS',                sortable: false },
]

export function colunasParaTipos(tipos, isProvedorTelmex = false) {
  const colunas =
      tipos.has('recuperacao') && !tipos.has('instalacao')
          ? RECUPERACAO_ORDENADA
          : [
            ...BASE,
            ...(tipos.has('recuperacao') ? RECUPERACAO : []),
            ...(tipos.has('instalacao')  ? INSTALACAO  : []),
          ]

  return colunas.map(c => ({ ...c, label: rotuloTelmex(c.key, c.label, isProvedorTelmex) }))
}
